<form *ngIf="datasetFormGroup" [formGroup]="datasetFormGroup">
    <p-card class="p-3" header="Datos generales">
        <div class="grid">
            <div class="col-10 input-field">
                <label for="name">Nombre * </label>
                <input pInputText formControlName="name" d-form-field-error />
            </div>
            <div class="col-2 input-field">
                <label for="iconClass">Activo</label>
                <p-inputSwitch formControlName="active" d-form-field-error></p-inputSwitch>
            </div>
            <div class="col-12 input-field">
                <label for="name">Consulta sql * </label>
                <div style="height: 400px;">
                    <ngx-monaco-editor *ngIf="editorVisible" [options]="editorOptionsSql" formControlName="sql"></ngx-monaco-editor>
                </div>
            </div>
        </div>

        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </p-card>
</form>

<p-card class="p-3" header="Configuración de campos">
    <div class="flex flex-column gap-2">
        <p-panel *ngFor="let field of datasetFields" header="{{field.name}}" [toggleable]="true" [collapsed]="true">
            <div class="grid">
                <div class="col-3 input-field">
                    <label for="name">Columna filtro * </label>
                    <input pInputText [(ngModel)]="field.columnName" d-form-field-error />
                </div>
                <div class="col-3 input-field">
                    <label for="name">Label * </label>
                    <input pInputText [(ngModel)]="field.label" d-form-field-error />
                </div>
                <div class="col-2 input-field">
                    <label for="name">Tipo * </label>
                    <p-dropdown [options]="dataTypes" [(ngModel)]="field.dataType" optionLabel="label" optionValue="value" d-form-field-error />
                </div>
                <div class="col-2 input-field">
                    <label for="name">Desplegable * </label>
                    <p-dropdown placeholder="No" [options]="optionsModes" [(ngModel)]="field.optionsMode" optionLabel="label" optionValue="value" d-form-field-error />
                </div>
                <div class="col-2 input-field">
                    <label>&nbsp;</label>
                    <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="saveField(field)"></p-button>
                </div>
                <div class="col-12 input-field" *ngIf="field.optionsMode == 'sql'">
                    <label for="name">Sql de opciones</label>
                    <div style="height: 200px;">
                        <ngx-monaco-editor [options]="editorOptionsSql" [(ngModel)]="field.optionsSql"></ngx-monaco-editor>
                        <small>Ejemplo: select Id, Name from table cs</small>
                    </div>
                </div>
                <div class="col-12 input-field" *ngIf="field.optionsMode == 'items'">
                    <label for="name">Lista de opciones</label>
                    <div style="height: 100px;">
                        <ngx-monaco-editor [options]="editorOptionsItems" [(ngModel)]="field.optionsItems"></ngx-monaco-editor>
                        <small>Ejemplo: [{{'{'}} "Id": 1, "Name": "Opción 1" {{'}'}}, {{'{'}} "Id": 2, "Name": "Opción 2" {{'}'}}]</small>
                    </div>
                </div>

            </div>
        </p-panel>
    </div>
</p-card>

<p-confirmDialog></p-confirmDialog>